import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "material-ui";
import { ModeEdit } from "material-ui-icons";
import { closePost, newPost } from "../actions/post.actions";
import { wrapComponent } from "../utils/container";
import NewCorrectionDialog from "./NewCorrectionDialog";
import NewPostDialog from "./NewPostDialog";
import { closeCorrection } from "../actions/correction.actions";
import PostActionSnackbar from "./PostActionSnackbar";

const styleSheet = theme => ({
    fabButton: {
        margin: theme.spacing.unit,
        position: "fixed",
        bottom: 2 * theme.spacing.unit,
        right: 2 * theme.spacing.unit
    }
});

class CorrectionPostDialog extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        correctionOpen: PropTypes.bool.isRequired,
        postOpen: PropTypes.bool.isRequired
    };

    onPostPageRequestClose = () => {
        this.props.dispatch(closePost());
    };

    onWritePostPressed = () => {
        this.props.dispatch(newPost());
    };

    onCorrectionDialogClose = () => {
        this.props.dispatch(closeCorrection());
    };

    render() {
        const { classes, correctionOpen, postOpen } = this.props;
        return (
            <React.Fragment>
                <PostActionSnackbar />
                <NewCorrectionDialog
                    open={correctionOpen}
                    onRequestClose={this.onCorrectionDialogClose}
                />
                <NewPostDialog
                    key="newPostDialog"
                    open={postOpen}
                    onRequestClose={this.onPostPageRequestClose}
                />
                <Button
                    fab
                    onClick={this.onWritePostPressed}
                    color="accent"
                    aria-label="new post"
                    className={classes.fabButton}>
                    <ModeEdit />
                </Button>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ createEditCorrection, createEditPost }) {
    return {
        correctionOpen: createEditCorrection.open,
        postOpen: createEditPost.open
    };
}

export default wrapComponent(CorrectionPostDialog, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/CorrectionPostDialogs.jsx